import { globalConfig } from '../../../config/globalConfig';
import DICTIONARIES from '../../Dictionaries/enums/dictionaries';
import { DictionaryItemParams } from '../../Dictionaries/interfaces/dictionaryItemParams';
import { MainMenuConfiguration } from '../interfaces/MainMenuConfiguration';
import { MainMenuItem } from '../interfaces/MainMenuItem';
import { AuthService } from '../../Auth/services/authServices';
import USER_AUTHORITIES from '../../Auth/enums/userAuthorities';

export class MainMenuService {
    static rootRoutePath: string = '/';
    static usersRoutePath: string = 'users';
    static ecoForumUsersRoutePath: string = 'eco-users';
    static newsRoutePath: string = 'news';
    static newsCategoriesRoutePath: string = 'categories';
    static newsListRoutePath: string = 'list';
    static transactionsRoutePath: string = 'transactions';
    static organizationsRoutePath: string = 'organizations';
    static socialCardsRoutePath: string = 'social-cards';
    static registrationRequestRoutePath: string = 'registration-request';
    static informationMessageRoutePath: string = 'information-center';
    static activitiesRoutePath: string = 'activities';
    static eventsRoutePath: string = 'events';
    static systemicRoutePath: string = 'systemic';
    static integrationRoutePath: string = 'integration';
    static statusRoutePath: string = 'status';
    static purchasesRoutePath: string = 'purchases';
    static applicationsRoutePath: string = 'applications';
    static servicesRoutePath: string = 'services';
    static analyticsRoutePath: string = 'analytics';
    static dictionariesRoutePath: string = 'dictionaries';
    static scoringRoutePath: string = 'scoring';
    static pollRoutePath: string = 'polls';
    static systemSettingsPath: string = 'system-settings';
    static partnerApplicationsRoutPath: string = 'partner-application';
    static registerOfBeneficiariesRoutePath: string = 'register-of-beneficiaries';
    static locationsRoutePath: string = 'locations';
    static mapRoutePath: string = 'map';
    static achievementsRoutePath: string = 'achievements';

    static get iconBasePath(): string {
        return 'assets/images/svg/';
    };

    /**
     * Конфигурация главного меню
     */
    static get mainMenuConfiguration(): MainMenuConfiguration {
        return {
            activities: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'activity',
                hide: AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                visibleName: 'Активности',
                family: MainMenuService.activitiesRoutePath,
                children: [
                    {
                        name: 'event',
                        family: MainMenuService.eventsRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.activitiesRoutePath}/event`,
                        visibleName: 'Событийные',
                    },
                    {
                        name: 'status',
                        visibleName: 'Статусные',
                        family: MainMenuService.statusRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.activitiesRoutePath}/status`,
                    },
                    {
                        name: 'systemic',
                        visibleName: 'Системные',
                        hide: globalConfig.partnerMode,
                        family: MainMenuService.systemicRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.activitiesRoutePath}/systemic`,
                    },
                    {
                        name: 'integration',
                        visibleName: 'Интеграционные',
                        hide: globalConfig.partnerMode,
                        family: MainMenuService.integrationRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.activitiesRoutePath}/integration`,
                    },
                    {
                        name: 'scoring',
                        visibleName: 'Ручное начисление баллов',
                        family: MainMenuService.scoringRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.activitiesRoutePath}/scoring`,
                    },
                ],
            },
            achievements: {
                name: 'achievements',
                visibleName: 'Достижения',
                family: MainMenuService.achievementsRoutePath,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                routePath: MainMenuService.achievementsRoutePath,
                hide: globalConfig.partnerMode,
            },
            registrationRequest: {
                name: 'registrationRequest',
                visibleName: 'Регистрация в активностях',
                hide: AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                family: MainMenuService.registrationRequestRoutePath,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                routePath: `/${MainMenuService.registrationRequestRoutePath}`,
            },
            news: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'news',
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                visibleName: 'Новости',
                family: MainMenuService.newsRoutePath,
                children: [
                    {
                        name: 'list',
                        family: MainMenuService.newsListRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.newsRoutePath}/list`,
                        visibleName: 'Новости',
                    },
                    {
                        name: 'categories',
                        visibleName: 'Категории новостей',
                        family: MainMenuService.newsCategoriesRoutePath,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        routePath: `/${MainMenuService.newsRoutePath}/categories`,
                    },
                ],
            },
            applications: {
                name: 'applications',
                visibleName: 'Заявки',
                hide: AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                family: MainMenuService.applicationsRoutePath,
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                routePath: '/applications',
            },
            services: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'services',
                visibleName: 'Услуги',
                hide: AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                family: MainMenuService.servicesRoutePath,
                routePath: '/services',
            },
            purchases: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                name: 'purchases',
                visibleName: 'Заказы',
                hide: AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                family: MainMenuService.purchasesRoutePath,
                routePath: '/purchases',
            },
            transactions: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                // Вкладка не скрывается в партнерском моде если юзер - Партнёр Экофорума
                hide: (globalConfig.partnerMode && !AuthService.userHasRole(USER_AUTHORITIES.ECOFORUM_PARTNER.value)) || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'transactions',
                visibleName: 'Биллинг',
                family: MainMenuService.transactionsRoutePath,
                routePath: `/${MainMenuService.transactionsRoutePath}`,
            },
            polls: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'polls',
                visibleName: 'Опросы',
                family: MainMenuService.pollRoutePath,
                routePath: `/${MainMenuService.pollRoutePath}`,
            },
            analytics: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'analytics',
                visibleName: 'Аналитика',
                family: MainMenuService.analyticsRoutePath,
                children: [
                    {
                        name: 'reports',
                        visibleName: 'Отчеты',
                        family: `${MainMenuService.analyticsRoutePath}/reports`,
                        routePath: `${MainMenuService.analyticsRoutePath}/reports`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                ],
            },
            organizations: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'organizations',
                visibleName: 'Организации',
                family: MainMenuService.organizationsRoutePath,
                routePath: `/${MainMenuService.organizationsRoutePath}`,
            },
            registerOfBeneficiaries: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || !(AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value) || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value)),
                name: 'register-of-beneficiaries',
                visibleName: 'Реестр льготников',
                family: MainMenuService.registerOfBeneficiariesRoutePath,
                routePath: `/${MainMenuService.registerOfBeneficiariesRoutePath}`,
                children: [
                    {
                        name: 'import-export-registry',
                        hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
                        visibleName: 'Управление реестром',
                        family: `${MainMenuService.registerOfBeneficiariesRoutePath}/management-registry`,
                        routePath: `${MainMenuService.registerOfBeneficiariesRoutePath}/management-registry`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                    {
                        name: 'list-beneficiaries',
                        hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value) && !AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                        visibleName: 'Список льготников',
                        family: `${MainMenuService.registerOfBeneficiariesRoutePath}/list-beneficiaries`,
                        routePath: `${MainMenuService.registerOfBeneficiariesRoutePath}/list-beneficiaries`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                    {
                        name: 'report-social-registry',
                        hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
                        visibleName: 'Отчеты',
                        family: `${MainMenuService.registerOfBeneficiariesRoutePath}/report-social-registry`,
                        routePath: `${MainMenuService.registerOfBeneficiariesRoutePath}/report-social-registry`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                    {
                        name: 'closed-registry',
                        hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
                        visibleName: 'Архив реестров закрытых периодов',
                        family: `${MainMenuService.registerOfBeneficiariesRoutePath}/closed-registry`,
                        routePath: `${MainMenuService.registerOfBeneficiariesRoutePath}/closed-registry`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                    {
                        name: 'municipal-areas',
                        hide: !AuthService.userHasRole(USER_AUTHORITIES.ADMIN.value),
                        visibleName: 'Муниципальные районы',
                        family: `${MainMenuService.registerOfBeneficiariesRoutePath}/municipal-areas`,
                        routePath: `${MainMenuService.registerOfBeneficiariesRoutePath}/municipal-areas`,
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                    },
                ],
            },
            socialCards: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'social-cards',
                visibleName: 'Социальные карты',
                family: MainMenuService.socialCardsRoutePath,
                routePath: `/${MainMenuService.socialCardsRoutePath}`,
            },
            users: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'users',
                visibleName: 'Пользователи',
                family: MainMenuService.usersRoutePath,
                routePath: `/${MainMenuService.usersRoutePath}`,
            },
            ecoForumUsers: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: !globalConfig.partnerMode || (globalConfig.partnerMode && !AuthService.userHasRole(USER_AUTHORITIES.ECOFORUM_PARTNER.value)),
                name: 'ecoForumUsers',
                visibleName: 'Пользователи Экофорума',
                family: MainMenuService.ecoForumUsersRoutePath,
                routePath: `/${MainMenuService.ecoForumUsersRoutePath}`,
            },
            informationMessage: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'informationMessage',
                visibleName: 'Информационный центр',
                family: MainMenuService.informationMessageRoutePath,
                routePath: `/${MainMenuService.informationMessageRoutePath}`,
                children: [
                    {
                        name: 'informationMessage',
                        visibleName: 'Информационные сообщения',
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        family: `${MainMenuService.informationMessageRoutePath}/messages-list`,
                        routePath: `${MainMenuService.informationMessageRoutePath}/messages-list`,
                    },
                    {
                        name: 'recipientsGroups',
                        visibleName: 'Группы получателей',
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        family: `${MainMenuService.informationMessageRoutePath}/recipients-groups`,
                        routePath: `${MainMenuService.informationMessageRoutePath}/recipients-groups`,
                    },
                ],
            },
            dictionaries: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'dictionaries',
                visibleName: 'Справочники',
                family: MainMenuService.dictionariesRoutePath,
                routePath: `/${MainMenuService.dictionariesRoutePath}`,
                children: Object
                    .values(DICTIONARIES)
                    .map((dictionary: DictionaryItemParams) => {
                        return ({
                            name: dictionary.path,
                            visibleName: dictionary.name,
                            iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                            family: `${MainMenuService.dictionariesRoutePath}/${dictionary.path}`,
                            routePath: `${MainMenuService.dictionariesRoutePath}/${dictionary.path}`,
                        });
                    }),
            },
            map: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: !AuthService.userHasRole(USER_AUTHORITIES.ECOFORUM_PARTNER.value),
                name: 'map',
                visibleName: 'Карта',
                family: MainMenuService.mapRoutePath,
                routePath: `/${MainMenuService.mapRoutePath}`,
            },
            partnerApplications: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'allApplications',
                visibleName: 'Заявки партнеров',
                family: MainMenuService.partnerApplicationsRoutPath,
                routePath: `/${MainMenuService.partnerApplicationsRoutPath}`,
                children: [
                    {
                        name: 'registration',
                        visibleName: 'Регистрация',
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        family: `${MainMenuService.partnerApplicationsRoutPath}/registration`,
                        routePath: `${MainMenuService.partnerApplicationsRoutPath}/registration`,
                    },
                    {
                        name: 'activity',
                        visibleName: 'Активности',
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        family: `${MainMenuService.partnerApplicationsRoutPath}/activity`,
                        routePath: `${MainMenuService.partnerApplicationsRoutPath}/activity`,
                    },
                    {
                        name: 'service',
                        visibleName: 'Услуги',
                        iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                        family: `${MainMenuService.partnerApplicationsRoutPath}/service`,
                        routePath: `${MainMenuService.partnerApplicationsRoutPath}/service`,
                    },
                ],
            },
            locations: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode
                    && !AuthService.userHasRole(USER_AUTHORITIES.ECOFORUM_PARTNER.value),
                name: 'locations',
                visibleName: 'Локации',
                family: MainMenuService.locationsRoutePath,
                routePath: `/${MainMenuService.locationsRoutePath}`,
            },
            systemSettings: {
                iconPath: `${MainMenuService.iconBasePath}archive.svg`,
                hide: globalConfig.partnerMode || AuthService.userHasRole(USER_AUTHORITIES.SOCIAL_REGISTRY_OPERATOR.value),
                name: 'system-settings',
                visibleName: 'Системные настройки',
                family: MainMenuService.systemSettingsPath,
                routePath: `/${MainMenuService.systemSettingsPath}`,
            },
        };
    }

    /**
     * Получить пункты меню
     */
    static get menuItems(): MainMenuItem[] {
        return Object.values(MainMenuService.mainMenuConfiguration);
    }
}
